export default __webpack_public_path__ + "static/media/dynamic_scroll_header.f4a456ed.MP4";